import 'normalize.css/normalize.css';
import '@devui-design/icons/icomoon/devui-icon.css';
import Icon from 'vue-devui-lal/icon';
import 'vue-devui-lal/icon/style.css';
import Input from 'vue-devui-lal/input';
import 'vue-devui-lal/input/style.css';
import 'core-js/features/string/replace-all';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import GlobalDirectives from '@/directives';
import { i18n } from './i18n';
import App from './App.vue';
import LocalInstall from 'vue-devui-lal/locale';
import { router, injectRouter } from '@/router';
import { IS_PROD } from '@/constant';
import '@/assets/css/main.scss';
import { ThemeServiceInit } from 'devui-theme';
import { storageApis } from './api/storage-apis';
import { storageService } from './utils/apiStorage';
import { gitCodeTheme } from './utils/theme/gitcodeTheme';
import { LANG_EN, LANG_KEY, LANGUAGE_ZH, LANGUAGE_EN } from '@/constant/lang';
import cookie from 'js-cookie';
import {
  VITE_HOST,
  VITE_TIANQI_HOST,
  VITE_API_HOST,
  VITE_CHAT_API_HOST,
  VITE_DEV_API_HOST,
  VITE_DEV_HOST,
  VITE_FILE_HOST,
  VITE_DOWNLOAD_HOST,
  VITE_CSDN_URL,
  VITE_ORG_COMMUNITY,
  VITE_STATIC_HOST,
  VITE_CHILD_HOMEWEB_HOST,
  VITE_USER_CENTER_HOST,
  VITE_GROWTH_CENTER_HOST,
  VITE_COPILOT_HOST,
  VITE_GICODE_CHAT_HOST,
  VITE_GICODE_CHAT_TIANQI_HOST,
  VITE_AI_HOST,
  VITE_NEWS_HOST,
  VITE_CODEARTS_HOST,
  VITE_COOKIE_DOMAIN,
  VITE_AD_LINK,
  VITE_AD_LINK_GROWTH,
  VITE_MAIN_API_HOST,
  VITE_INTERPAGE_HOST,
  VITE_MIGRATION_NOTICE,
  VITE_COMPETITION_HOST,
  VITE_HOST_TIANQI
} from '@/utils/tools';
import { setLayoutConfig } from 'vue-layout-gitcode';

// 将 import.meta.env 中的所有环境变量转换为一个普通对象，传递给 vue-layout-gitcode
const layoutConfig = {
  VITE_HOST: VITE_HOST(),
  VITE_TIANQI_HOST: VITE_TIANQI_HOST(),
  VITE_API_HOST: VITE_API_HOST(),
  VITE_CHAT_API_HOST: VITE_CHAT_API_HOST(),
  VITE_DEV_API_HOST: VITE_DEV_API_HOST(),
  VITE_DEV_HOST: VITE_DEV_HOST(),
  VITE_FILE_HOST: VITE_FILE_HOST(),
  VITE_DOWNLOAD_HOST: VITE_DOWNLOAD_HOST(),
  VITE_CSDN_URL: VITE_CSDN_URL(),
  VITE_ORG_COMMUNITY: VITE_ORG_COMMUNITY(),
  VITE_STATIC_HOST: VITE_STATIC_HOST(),
  VITE_CHILD_HOMEWEB_HOST: VITE_CHILD_HOMEWEB_HOST(),
  VITE_USER_CENTER_HOST: VITE_USER_CENTER_HOST(),
  VITE_GROWTH_CENTER_HOST: VITE_GROWTH_CENTER_HOST(),
  VITE_COPILOT_HOST: VITE_COPILOT_HOST(),
  VITE_GICODE_CHAT_HOST: VITE_GICODE_CHAT_HOST(),
  VITE_GICODE_CHAT_TIANQI_HOST: VITE_GICODE_CHAT_TIANQI_HOST(),
  VITE_AI_HOST: VITE_AI_HOST(),
  VITE_NEWS_HOST: VITE_NEWS_HOST(),
  VITE_CODEARTS_HOST: VITE_CODEARTS_HOST(),
  VITE_COOKIE_DOMAIN: VITE_COOKIE_DOMAIN(),
  VITE_AD_LINK: VITE_AD_LINK(),
  VITE_AD_LINK_GROWTH: VITE_AD_LINK_GROWTH(),
  VITE_MAIN_API_HOST: VITE_MAIN_API_HOST(),
  VITE_INTERPAGE_HOST: VITE_INTERPAGE_HOST(),
  VITE_MIGRATION_NOTICE: VITE_MIGRATION_NOTICE(),
  VITE_COMPETITION_HOST: VITE_COMPETITION_HOST(),
  VITE_HOST_TIANQI: VITE_HOST_TIANQI(),
  VITE_IMG_TRANSFER: import.meta.env.VITE_IMG_TRANSFER,
  VITE_GSTAR_TOPIC: import.meta.env.VITE_GSTAR_TOPIC,
  VITE_TRUSTED_TOPIC: import.meta.env.VITE_TRUSTED_TOPIC,
  VITE_INCUBATION_TOPIC: import.meta.env.VITE_INCUBATION_TOPIC,
  VITE_SEARCH_REPO_CHANNEL_ID: import.meta.env.VITE_SEARCH_REPO_CHANNEL_ID
};
// @ts-ignore
setLayoutConfig(layoutConfig);

const themeService = ThemeServiceInit({ 'gitcode-theme': gitCodeTheme }, 'gitcode-theme');
themeService?.applyTheme(gitCodeTheme);
declare global {
  interface Window {
    collectEvent?: (sendbeacon: 'beconEvent', event: string, data: Record<string, any>) => void;
    initNECaptchaWithFallback?: (config: any, onload: (instance: any) => void, onerror: (err: any) => void) => void;
  }
}

storageService.setInstanceName('gitcode');
// 缓存策略表
storageService.setRequestCacheList(storageApis);

// 注册全局指令
const app = createApp(App);
app.use(createPinia());
app.use(i18n);
// tingyun上传js错误
if (IS_PROD) {
  app.config.errorHandler = (err, _instance, _info) => {
    if (window?.TINGYUN) {
      window.TINGYUN.captureException(err);
    }
  };
}
app.use(Icon);
app.use(Input);
app.use(GlobalDirectives);
// 指定语言初始化使用
const lang = cookie.get(LANG_KEY) || localStorage.getItem(LANG_KEY) || LANGUAGE_ZH;
let langStr = LANGUAGE_ZH;
if (lang === LANG_EN) {
  langStr = LANGUAGE_EN;
}

app.use(LocalInstall, langStr);
/* 权限验证 */
injectRouter(router);
app.use(router);
// 屏蔽警告信息
app.config.warnHandler = () => null;

app.mount('#app');

// const user_center_url = (import.meta as any).env.VITE_USER_CENTER_HOST;

// console.log('buildTime', BUILD_TIME); // 环境变量-最后一次打包时间，用于知晓正式是否更新
